import { render } from "./A101010.vue?vue&type=template&id=132c9669&scoped=true"
import script from "./A101010.vue?vue&type=script&lang=js"
export * from "./A101010.vue?vue&type=script&lang=js"

import "./A101010.vue?vue&type=style&index=0&id=132c9669&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132c9669"]])

export default __exports__